document.addEventListener('variant:change', function(event) {
  const color = event.detail.variant.options[0].toLowerCase();
  const tag = `color:${color}`;

  document.querySelectorAll('.product-media-container').forEach(el => {
    const alt = el.querySelector('img')?.alt?.toLowerCase() || '';

    if (alt.includes(tag) || alt === '') {
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  });
});

